module.exports = __webpack_public_path__ + "static/media/man_holding-laptop.cb0e982d.jpg";